import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

import { campaignKeywordsSchema, campaignResponseSchema, campaignTrackItemSchema } from '../schema';
import type { Campaign } from '../type';

export const createCampaignRequestSchema = z.object({
  name: z.string().trim().min(1),
  start_date: z.string().trim().min(1),
  end_date: z.string().trim().min(1).optional(),
  added_items: z.array(campaignTrackItemSchema).optional(),
  ...campaignKeywordsSchema.shape,
});

export type CreateCampaignRequest = z.infer<typeof createCampaignRequestSchema>;

export async function CreateCampaign(
  workspaceId: string,
  request: CreateCampaignRequest,
  signal?: AbortSignal,
): Promise<Campaign> {
  const parsedRequest = createCampaignRequestSchema.parse(request);
  const response = await socialApiClient.post(`workspaces/${workspaceId}/campaigns`, {
    json: parsedRequest,
    signal,
  });
  return campaignResponseSchema.parse(await response.json());
}
